import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { LEASE_VIEW_TYPES } from '../models/Lease';
import TenantLeaseSummary from './TenantLeaseView/TenantLeaseSummary';
import { trackError } from '../utils/trackError';
import TenantSelfServeView from './TenantLeaseView/TenantSelfServeView';
import { useLeasingUrlParams } from '../hooks/useLeasingUrlParams';
import { useLeaseQuery } from '../utils/queries';

function TenantLeaseView() {
  const history = useHistory();
  const { leaseId, nestedViewType } = useLeasingUrlParams();

  const leaseQuery = useLeaseQuery(leaseId, { enabled: !!leaseId });
  const lease = leaseQuery.data;

  useEffect(() => {
    if (!lease) {
      return;
    }

    lease.forceRedirectIfWrongViewType(history, nestedViewType as LEASE_VIEW_TYPES, trackError);
  }, [lease, history, nestedViewType]);

  return nestedViewType === LEASE_VIEW_TYPES.SELF_SERVE ? <TenantSelfServeView /> : <TenantLeaseSummary />;
}

export default TenantLeaseView;
